import React from 'react'
import { connect } from 'react-redux'
import { formatPrice } from '../common/Functions';
import { closePopup, placeOrder } from '../redux/actions/cart';


function Footer({ multiOrderPopupShown, closePopup, cartTotal, cartDetails, placeOrder }) {

    const tmpPlaceorder = () => {
        placeOrder();
    }

    if (!cartDetails?.cart?.cart_content.length> 0) {
        return null;
    }

    return (
        <footer>
            <div className="bottom-action" onClick={tmpPlaceorder}>
                <div className="left">
                    <p className="text-white"><span className="text-white d-inline-block pr-10">Total</span><span className="font-bold">{formatPrice(cartDetails?.cart?.grand_total?.amount_pretty)}</span></p>

                </div>
                <div className="right">
                    <button className="btn-bottom text-white" >Place Order <span className="fa fa-long-arrow-right"></span></button>
                </div>
            </div>
        </footer>)

    /* {/*<footer>
         {!multiOrderPopupShown &&
             <div className="floating-info active">
                 <p>You can continue adding items from the menu and choose to make the payment later</p>
                 <div className="bottom">
                     <div className="custom-checkbox">
                         <input type="checkbox" checked="checked" />
                         <span className="checkmark"></span>
                     </div>
                     <span>Do not show this message again</span>
                     <span className="close-floating-info fa fa-close" onClick={() => closePopup()}></span>
                 </div></div>}
         <div className="total-cart-bottom">
             <span className="text-white d-inline-block pr-10">Cart Total</span>
             <span className="font-bold text-white"> {cartTotal} </span>
         </div>
         </footer>}
    ) */
}

const mapStateToProps = (state) => ({
    multiOrderPopupShown: state.cart.multiOrderPopupShown,
    cartTotal: state.cart.serverCart?.cart?.grand_total?.amount_pretty

})

export default connect(mapStateToProps, { closePopup, placeOrder })(Footer)
